import { alpha, MenuItem, SxProps, TextField } from "@mui/material";
import { useContext } from "react";
import { EntityAuthOption } from "src/services/link/queries/NetTypes";

import Context from "../../context";

// ----------------------------------------------------------------------

const sxItem: SxProps = {
	mx: 1,
	my: 0.5,
	borderRadius: 0.75,
	typography: "body2"
};

type Props = {
	onChangeSelect: (value: string) => void;
	selectedValue: string;
	values: EntityAuthOption[];
	label: string;
};

export const LoginSelector = ({ values, onChangeSelect, selectedValue, label }: Props) => {
	const { entity, customConnectProps } = useContext(Context);

	const { theme } = customConnectProps!;

	return (
		<TextField
			fullWidth
			select
			disabled={entity?.maintenance}
			label={label}
			value={selectedValue}
			onChange={(e: any) => onChangeSelect(e.target.value)}
			sx={{
				"& label": {
					color: theme?.colors?.primaryText ?? "white"
				},
				"& .MuiOutlinedInput-root": {
					"& fieldset": {
						borderColor: alpha(theme?.colors.stroke ?? "#000", 0.3)
					},
					"&:hover fieldset": {
						borderColor: theme?.colors.primary
					},
					"&.Mui-focused fieldset": {
						borderColor: theme?.colors.primary
					},
					"& input": {
						color: theme?.colors.primaryText
					}
				},
				"& .MuiSelect-select": {
					color: theme?.colors.primaryText
				}
			}}
			InputLabelProps={{
				style: {
					color: alpha(theme?.colors.secondaryText ?? "#000", 0.8)
				}
			}}
		>
			{values.map((option, index) => (
				<MenuItem key={index} value={option.value} sx={sxItem}>
					{option.label}
				</MenuItem>
			))}
		</TextField>
	);
};

export default LoginSelector;
